<template>
    <div class="fh ablauf">
        <div class="row fh">
            <div class="col">
                <br>
                <br>

                <div class="schedule-item">
                    <div class="schedule-item-left">
                        <h6>14:00 Uhr</h6>
                    </div>

                    <div class="d-xs-none schedule-item-line">
                        <div class="schedule-item-line-circle"></div>
                        <div class="schedule-item-line-line"></div>
                    </div>

                    <div class="schedule-item-right">
                        <h6>Gottesdienst in der Oberen Pfarre</h6>
                        <p>Wir starten das offizielle Programm mit einem Gottesdienst in der Oberen Pfarre in Bamberg.</p>
                        <p>Bitte denkt an einen Mund-Nasen-Schutz und beachtet auch die aushängenden Informationen zum Corona-Schutz. In der Kirche gibt es gekennzeichnete Sitzplätze, die euch am Eingang ein Ordner zeigt. An eurem Sitzplatz gilt keine Maskenpflicht.</p>
                    </div>
                </div>

                <div class="schedule-item">
                    <div class="schedule-item-left">
                        <h6>&nbsp;</h6>
                    </div>

                    <div class="schedule-item-line">
                        <div class="schedule-item-line-circle"></div>
                        <div class="schedule-item-line-line"></div>
                    </div>

                    <div class="schedule-item-right">
                        <h6>Sektempfang</h6>
                        <p>Nach dem Gottesdienst gibt es auf dem Kirchenvorplatz einen Sektempfang.</p>
                    </div>
                </div>

                <div class="schedule-item">
                    <div class="schedule-item-left">
                        <h6>&nbsp;</h6>
                    </div>

                    <div class="schedule-item-line">
                        <div class="schedule-item-line-circle"></div>
                        <div class="schedule-item-line-line"></div>
                    </div>

                    <div class="schedule-item-right">
                        <h6>Gruppenfoto</h6>
                    </div>
                </div>

                <div class="schedule-item">
                    <div class="schedule-item-left">
                        <h6>16:15 Uhr</h6>
                    </div>

                    <div class="schedule-item-line">
                        <div class="schedule-item-line-circle"></div>
                        <div class="schedule-item-line-line"></div>
                    </div>

                    <div class="schedule-item-right">
                        <h6>Kaffee &amp; Kuchen</h6>
                        <p>Für Kaffee und Kuchen treffen wir uns im Ristorante Da Francesco am Kloster Michelsberg. Von der Kirche seid ihr in ca. 15 Minuten zu Fuß beim Restaurant.</p>
                    </div>
                </div>

                <div class="schedule-item">
                    <div class="schedule-item-left">
                        <h6>19:00 Uhr</h6>
                    </div>

                    <div class="schedule-item-line">
                        <div class="schedule-item-line-circle"></div>
                        <div class="schedule-item-line-line"></div>
                    </div>

                    <div class="schedule-item-right">
                        <h6>Abendessen</h6>
                        <p>Zum Abendessen könnt ihr aus verschiedenen Hauptspeisen wählen. Teilt uns bitte rechtzeitig eventuelle Unverträglichkeiten mit.</p>
                    </div>
                </div>

                <div class="schedule-item">
                    <div class="schedule-item-left">
                        <h6>&nbsp;</h6>
                    </div>

                    <div class="schedule-item-line">
                        <div class="schedule-item-line-circle"></div>
                    </div>

                    <div class="schedule-item-right">
                        <h6>Abendprogramm</h6>
                        <p>Nach dem Abendessen wollen wir den Abend in gemütlicher Runde ausklingen lassen. Ein festes Ende gibt es hierbei nicht.</p>
                    </div>
                </div>
            </div>

            <div class="d-none d-lg-block col fh">
                <div class="image-grid fh">
                    <div class="ig-row">
                        <div class="row no-gutters fh">
                            <div class="col ig-col">
                                <div class="image" ref="sticky">
                                    <l-map ref="ablaufMap"
                                           :zoom="zoom"
                                           :center="center">
                                        <l-tile-layer :url="tileUrl"></l-tile-layer>
                                        <l-marker :lat-lng="[49.8938,10.8760]" @click="goToRestaurant"></l-marker>
                                        <l-marker :lat-lng="[49.88925,10.8843]" @click="goToChurch"></l-marker>
                                    </l-map>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import { Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
    name: 'home',
    components: {
        LMap, 
        LTileLayer, 
        LMarker
    },
    data: function () {
        return {
            tileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            zoom: 16,
            center: [49.8915943, 10.88]
        }
    },
    mounted() {
        const sticky = this.$refs.sticky

        document.getElementById('main').addEventListener('scroll', (e) => {
            sticky.style.transform = `translateY(${e.target.scrollTop}px)`
        })
    },
    methods: {
        goToRestaurant() {
            window.open('https://goo.gl/maps/1FPYuuxDkRcTqjgh7')
        },
        goToChurch() {
            window.open('https://goo.gl/maps/QHaonKyBs2FGHARF8')
        }
    }
}
</script>

<style lang="scss">
@import "~bootstrap";

.image-grid {
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-evenly;
    align-items: stretch;
    align-content: stretch;
}

.ig-row {
    flex: 1 0 auto;
}

.margin-bottom {
    margin-bottom: 1rem;
}

.pl {
    padding-left: 1rem !important;
}

.ig-col {
    height: 100%;
}

div.image {
    width: 100%;
    height: 100%;
    background-color: cadetblue;
}

.fh {
    height: 100%;
}

/* SCHEDULE */
.schedule-item {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: flex-start;
    align-items: flex-start;
}

.schedule-item-left {
    flex: 0 1 auto;
    align-self: auto;

    color: rgb(53, 58, 71);
        
    width: 4rem;

    transform: translateY(-0.15rem);
}

.schedule-item-right {
    flex: 1 0 auto;
    align-self: auto;

    background: rgb(53, 58, 71);
    color: whitesmoke;
    padding: 0.5rem;
    margin: 0.5rem 0 0 0.5rem;

    width: 40%;

    transform: translateY(-1.3rem);
}

.schedule-item-right:before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-right: 8px solid rgb(53, 58, 71);
    left: -0.5rem;
    top: 1.3rem;
    transform: translateY(-0.5rem);
}

.schedule-item-line {
    flex: 0 1 auto;
    align-self: stretch;

    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: center;
}

.schedule-item-line-circle {
    flex: 0 1 auto;
    border-radius: 50%;
    height: 1rem;
    width: 1rem;
    border: 0.2rem #636363 solid;
    background: white;
}

.schedule-item-line-line {
    width: 0.2rem;
    background: #636363;
    flex: 1 1 auto;
}

.schedule-end {
    border: 2px solid #636363;
    padding: 0.4rem;
}

@include media-breakpoint-down(md) {
    .ablauf {
        margin: 0 1rem;
    }
} 
</style>
